import React from "react";
import NumberFormat from "react-number-format";
import alertConfig from "constants/alertConfig";

import { StyledDropdown } from "./Styles";

export var NoDecimalPercentFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={0}
      allowNegative
      suffix="%"
      {...other}
    />
  );
};

export var TwoDecimalPercentFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={2}
      allowNegative
      suffix="%"
      {...other}
    />
  );
};

export var DSCRFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={2}
      allowNegative
      suffix="x"
      {...other}
    />
  );
};

export var ThreeDecimalPercentFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={3}
      allowNegative
      suffix="%"
      {...other}
    />
  );
};

export var FiveDecimalPercentFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={5}
      allowNegative
      suffix="%"
      {...other}
    />
  );
};

export var FourDecimalPercentFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={4}
      allowNegative
      suffix="%"
      {...other}
    />
  );
};

export var FiveDecimalFloatFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={5}
      thousandSeparator
      allowNegative
      {...other}
    />
  );
};

export var ThreeDecimalFloatFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={3}
      thousandSeparator
      allowNegative
      {...other}
    />
  );
};

export var TwoDecimalFloatFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={2}
      thousandSeparator
      allowNegative
      {...other}
    />
  );
};

export var FloatFormat = props => {
  const { inputRef, selectedItem, handleTextChange, name, value, onChange, ...other } = props;

  return (
    <NumberFormat
      value={value}
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      decimalScale={0}
      thousandSeparator
      allowNegative
      {...other}
    />
  );
};

export var DollarFormat = props => {
  const { inputRef, name, value, onChange, scale, fix, ...other } = props;

  return (
    <NumberFormat
      value={value}
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      thousandSeparator
      prefix="$"
      decimalScale={0}
      allowNegative
      {...other}
    />
  );
};

export var DollarAndCentFormat = props => {
  const { inputRef, name, value, onChange, scale, fix, ...other } = props;

  return (
    <NumberFormat
      value={value}
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      thousandSeparator
      prefix="$"
      decimalScale={2}
      allowNegative
      {...other}
    />
  );
};

export var BooleanFormat = props => {
  const { inputRef, name, value, onChange, scale, fix, ...other } = props;

  return (
    <StyledDropdown
      id="booleanFormatStyledDropdown"
      margin="dense"
      selectedValue={value}
      onChange={values => {
        onChange({ target: { name, value: values.value } });
      }}
      inputProps={{ name }}
      options={alertConfig.EXTENSION_QUALIFICATION_OPTIONS}
    />
  );
};
